export enum UserAssignmentsPermissions {
  ASSIGN_USER = 'userAssignments.assignUser',
}
